import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { isWaypointsOpenAtom } from '../../Waypoints/WaypointState';
import { isAllSimpleWindowsOpenAtom, isClusterEnabledAtom } from '../../OnlineMapState';
import {
  mapInfoWindowAlarmsAtom,
  mapInfoWindowEventsAtom,
  mapInfoWindowIdentificationAtom,
} from './InfoWindowState';
import useAnalytics from '../../../../hooks/useAnalytics';

export default function VehicleChipsControl(): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isAllSimpleWindowsOpen, setIsAllSimpleWindowsOpen] = useRecoilState<boolean>(
    isAllSimpleWindowsOpenAtom
  );
  const setIsWaypointsOpen = useSetRecoilState(isWaypointsOpenAtom);
  const identification = useRecoilValue(mapInfoWindowIdentificationAtom);
  const alarms = useRecoilValue(mapInfoWindowAlarmsAtom);
  const events = useRecoilValue(mapInfoWindowEventsAtom);
  const clusters = useRecoilValue(isClusterEnabledAtom);
  const { trackEvent } = useAnalytics();

  const handleToggleVehicleMapSettings = (
    _event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    trackEvent(['map', 'click', 'Settings for vehicles on map']);
    if (isAllSimpleWindowsOpen) {
      setIsAllSimpleWindowsOpen(false);
      setIsWaypointsOpen(false);
    } else {
      setIsAllSimpleWindowsOpen(true);
      setIsWaypointsOpen(false);
    }
  };

  return (
    <button
      onClick={handleToggleVehicleMapSettings}
      data-cy="controls-on-map-vehicles-info"
      title={f({ id: 'map.vehicles.info' })}
      className={`e-button-sq text-primary  ${
        (identification || alarms || events || clusters) && isAllSimpleWindowsOpen === false
          ? `bubble-on`
          : ``
      }`}
      style={isAllSimpleWindowsOpen === false ? { color: '#737373' } : {}}
    >
      <svg width="16px" height="16px" viewBox="0 0 16 16">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M4.66666667,1.12727273 L4.66666667,13.9181818 L0.866666667,15 L0.666666667,15 C0.533333333,15 0.4,14.9363636 0.266666667,14.8727273 C0.0666666667,14.7454545 0,14.5545455 0,14.3636364 L0,2.90909091 C0,2.65454545 0.2,2.4 0,2.27272727 L4.66666667,1.12727273 Z M6,1.12727273 L10,2.08181818 L9.99999021,6.42265658 C9.6930258,6.48498697 9.43246423,6.68778419 9.29692582,6.97114564 L9.25852267,7.05143264 C9.10221722,7.3782104 8.76057172,7.57474113 8.39951143,7.54557676 L7.98545754,7.51213186 C7.53885821,7.47605813 7.12277406,7.74144813 6.96717945,8.16161785 L6.08992539,10.5305661 C5.99848218,10.7775005 6.0081268,11.0505369 6.11676556,11.2904037 L6.30178996,11.6989247 C6.45182842,12.0301992 6.41019482,12.4168128 6.19306581,12.7085478 L6,12.967 L6,1.12727273 Z M15.1333333,1 C15.3333333,1 15.6,1 15.7333333,1.12727273 C15.9333333,1.25454545 16,1.44545455 16,1.63636364 L15.9998366,7.53677992 C15.7523647,7.31847651 15.4099056,7.23597092 15.0867421,7.32250094 C14.7489352,7.41295186 14.3941955,7.25272569 14.2387288,6.93947664 L13.9901343,6.43858472 C13.7924447,6.04026091 13.3554748,5.82033251 12.9177814,5.89886588 L11.333,6.183 L11.3333333,2.08181818 Z"
            id="Combined-Shape"
            className="fill-primary"
            fill="#737373"
          />
          <path
            d="M15.1470514,12.4843333 C15.1760544,12.324303 15.1912382,12.1623306 15.1924543,12 C15.1912382,11.8376694 15.1760544,11.675697 15.1470514,11.5156667 L15.8919421,10.8393333 C16.0088042,10.7330657 16.0338034,10.5657327 15.9525975,10.4333333 L15.4205327,9.56666667 C15.3382454,9.43482081 15.1717003,9.37169714 15.0150994,9.413 L14.0219118,9.67966667 C13.7530084,9.47384228 13.4502723,9.31048749 13.12556,9.196 L12.876199,8.25266667 C12.8368011,8.10422394 12.6949318,8 12.5321305,8 L11.4680009,8 C11.3051996,8 11.1633303,8.10422394 11.1239324,8.25266667 L10.8731525,9.196 C10.548939,9.31061734 10.2466916,9.47396698 9.97821957,9.67966667 L8.985032,9.413 C8.8284383,9.37182021 8.66197159,9.43491415 8.57959865,9.56666667 L8.04753388,10.4333333 C7.96614058,10.5658113 7.99114948,10.7333471 8.10818926,10.8396667 L8.85307994,11.516 C8.82409601,11.6759205 8.8089123,11.8377807 8.80767708,12 C8.80889319,12.1623306 8.82407697,12.324303 8.85307994,12.4843333 L8.10818926,13.1606667 C7.99132714,13.2669343 7.96632802,13.4342673 8.04753388,13.5666667 L8.57959865,14.4333333 C8.64302317,14.5365676 8.76028297,14.6001161 8.88713208,14.6 C8.92010101,14.5998614 8.95290381,14.5956018 8.98467729,14.5873333 L9.97786486,14.3206667 C10.2467683,14.5264911 10.5495044,14.6898458 10.8742166,14.8043333 L11.1249965,15.7476667 C11.1644351,15.8956161 11.3056997,15.9995383 11.4680009,16 L12.5321305,16 C12.6949318,16 12.8368011,15.8957761 12.876199,15.7473333 L13.1269789,14.804 C13.4511924,14.6893827 13.7534398,14.526033 14.0219118,14.3203333 L15.0150994,14.587 C15.0468728,14.5952685 15.0796756,14.5995281 15.1126446,14.5996667 C15.2394937,14.5997828 15.3567535,14.5362343 15.420178,14.433 L15.9522428,13.5663333 C16.0336361,13.4338553 16.0086272,13.2663195 15.8915874,13.16 L15.1470514,12.4843333 Z M12,13 C11.4477153,13 11,12.5522847 11,12 C11,11.4477153 11.4477153,11 12,11 C12.5522847,11 13,11.4477153 13,12 C13,12.2652165 12.8946432,12.5195704 12.7071068,12.7071068 C12.5195704,12.8946432 12.2652165,13 12,13 Z"
            id="Shape"
            className="fill-primary"
            fill="#737373"
          />
        </g>
      </svg>
      <span className="sr-only">{f({ id: 'map.vehicles.info' })}</span>
    </button>
  );
}
